<template>
    <div class="loading">
        <van-loading size="24px" color="#BF0000" vertical>加载中...</van-loading>
    </div>
</template>

<script>
export default {
    name:'Loading',
    data(){
        return{

        }
    }
}
</script>

<style lang="scss" scoped>
.loading{
    position:fixed;
    left:0;
    top:0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    background:#fff;
    .van-loading{
        width:300px;
        height:180px;
        padding:60px 0;
        background:rgba(0,0,0,.5);
        position:absolute;
        border-radius:28px;
        top:50%;
        margin-top:-228px;
        left:50%;
        margin-left:-150px;
        .van-loading__spinner{
            width:80px !important;
            height:80px !important;
            margin-bottom:50px;
        }
        .van-loading__text{
            color:#fff;
            font-size:30px;
        }
    }
}
</style>